import { render, staticRenderFns } from "./InstructionDialog.vue?vue&type=template&id=8deb9382&scoped=true"
import script from "./InstructionDialog.vue?vue&type=script&lang=js"
export * from "./InstructionDialog.vue?vue&type=script&lang=js"
import style0 from "./InstructionDialog.vue?vue&type=style&index=0&id=8deb9382&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deb9382",
  null
  
)

export default component.exports